module.exports = {
    ch: '零壹貳參肆伍陸柒捌玖'
    ,ch_u: '個拾佰仟萬億'
    ,ch_f: '負'
    ,ch_d: '點'
    ,m_t: '$'
    ,m_z: '整'
    ,m_u: '圓角分'
}